import { render, staticRenderFns } from "./PowerBI.vue?vue&type=template&id=12da7309&scoped=true"
import script from "./PowerBI.vue?vue&type=script&lang=js"
export * from "./PowerBI.vue?vue&type=script&lang=js"
import style0 from "./PowerBI.vue?vue&type=style&index=0&id=12da7309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da7309",
  null
  
)

export default component.exports